module.exports = __webpack_public_path__ + "static/media/add-img-icon.665624f7.svg";